import { Component, OnInit, EventEmitter, Output, Input } from "@angular/core";

@Component({
	selector: "app-custom-popover",
	templateUrl: "./custom-popover.component.html",
	styleUrls: ["./custom-popover.component.scss"],
})
export class CustomPopoverComponent implements OnInit {
	isDropdownOpen = false;
	//type de opciones [{optionLabel: "label", id:0}, {optionLabel: "label2", id:1}]
	@Input() optionsList;
	@Input() lgContainer;

	@Output() optionSelected = new EventEmitter<string>();

	constructor() {}

	ngOnInit() {
		
	}

	toggleDropdown() {
		this.isDropdownOpen = !this.isDropdownOpen;
	}

	onOptionSelected(option: string) {
		this.optionSelected.emit(option);
		this.isDropdownOpen = false;
	}

	handleClickedOutside() {
		this.isDropdownOpen = false;
	}
}
